/* Product tabs (moved from sections/product-tabs.liquid). */
(function () {
  function init(section) {
    if (!section || section.dataset.tabsReady === 'true') return;
    section.dataset.tabsReady = 'true';

    var tabs = section.querySelectorAll('.tab-nav li');
    var contents = section.querySelectorAll('.tab-content');

    function activateTab(tabId) {
      var targetTab = section.querySelector('.tab-nav li[data-tab="' + tabId + '"]');
      var targetContent = section.querySelector('.tab-content[id="' + tabId + '"]');
      if (!targetTab || !targetContent) return false;
      tabs.forEach(function (tab) { tab.classList.remove('active'); tab.setAttribute('aria-selected', 'false'); });
      contents.forEach(function (content) { content.classList.remove('active'); });
      targetTab.classList.add('active');
      targetTab.setAttribute('aria-selected', 'true');
      targetContent.classList.add('active');
      setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 100);
      return true;
    }

    var initialHash = window.location.hash.replace('#', '');
    if (!(initialHash && activateTab(initialHash)) && tabs.length) {
      activateTab(tabs[0].getAttribute('data-tab'));
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = this.getAttribute('data-tab');
        activateTab(target);
        history.replaceState(null, '', '#' + target);
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        }
      });
    });
  }

  function initAll() { document.querySelectorAll('.product-tabs-section').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
